import Icon from 'veui/components/Icon'

Icon.register({
  sync: {
    paths: [
      {
        d: 'M4.5 36.2V41a2 2 0 11-4 0V24a2 2 0 012.25-1.98L3 22a2 2 0 012 2 19 19 0 0036.34 7.77A2 2 0 1145 33.41a23 23 0 01-40.49 2.8zm39-24.4V7a2 2 0 114 0v17a2 2 0 01-2.25 1.98L45 26a2 2 0 01-2-2 19 19 0 00-36.34-7.77A2 2 0 113 14.59a23 23 0 0140.49-2.8z'
      }
    ],
    width: '48',
    height: '48'
  }
})
